<div class="transport-options-editor no-field-space">
  <sc-padding>
    <form [formGroup]="optionFormGroup">

      <mat-slide-toggle formControlName="onlyInternal" name="onlyInternal">
        {{'internal only' | translate: ['tmc-yard.entity.transport-option.only-internal',
        translationService.language]}}
      </mat-slide-toggle>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>{{'font color' | translate: ['tmc-yard.entity.transport-option.color',
          translationService.language]}}</mat-label>
        <app-color-picker (colorSelected)="colorPickerChanged($event)" formControlName="colorPickerColor" />
      </mat-form-field>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <mat-slide-toggle formControlName="globalConnectNotificationsEnabled" name="globalConnectNotificationsEnabled">
        {{'global connect notifications enabled' | translate:
        ['tmc-yard.entity.transport-option.global-connect-notifications-enabled',
        translationService.language]}}
      </mat-slide-toggle>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <mat-slide-toggle formControlName="noProcessingTimeThreshold" name="noProcessingTimeThreshold">
        {{'no processing time threshold' | translate:
        ['tmc-yard.entity.transport-option.no-processing-time-threshold',
        translationService.language]}}
      </mat-slide-toggle>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <sc-number-field formControlName="permittedProcessingTime" [required]="true"
        [label]="'permitted processing time' | translate: ['tmc-yard.entity.transport-option.permitted-processing-time', translationService.language]">
      </sc-number-field>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <mat-slide-toggle formControlName="preventGapsOnMultipleSlots" name="preventGapsOnMultipleSlots">
        {{'prevent gaps on multiple slots' | translate:
        ['tmc-yard.entity.transport-option.prevent-gaps-on-multiple-slots',
        translationService.language]}}
      </mat-slide-toggle>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>
          {{'booking offset type' | translate: ['tmc-yard.entity.transport-option.booking-offset-type',
          translationService.language]}}
        </mat-label>
        <mat-select formControlName="bookingOffsetType">
          <mat-option *ngFor="let bookingOffsetType of bookingOffsetTypeOptions" [value]="bookingOffsetType">
            {{bookingOffsetType | translate: ['tmc-yard.entity.transport-option.booking-offset-type.'+bookingOffsetType,
            translationService.language]}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <sc-content-spacer [vertical]="true"></sc-content-spacer>

      <ng-container *ngIf="this.transportOption.bookingOffsetType === bookingOffsetType.HOURS">
        <sc-number-field formControlName="bookingOffsetHours" [required]="true"
          [label]="'booking offset hours' | translate: ['tmc-yard.entity.transport-option.booking-offset-hours', translationService.language]">
        </sc-number-field>
      </ng-container>

      <ng-container *ngIf="this.transportOption.bookingOffsetType === bookingOffsetType.TIME_AND_WORKDAYS">
        <sc-time-field formControlName="bookingOffsetTime" [required]="true"
          [label]="'booking offset time' | translate: ['tmc-yard.entity.transport-option.booking-offset-time', translationService.language]"></sc-time-field>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <sc-number-field formControlName="bookingOffsetDays" [required]="true"
          [label]="'booking offset days' | translate: ['tmc-yard.entity.transport-option.booking-offset-days', translationService.language]"></sc-number-field>
      </ng-container>

    </form>
  </sc-padding>
</div>
